import type { Customer, Job, JobFile, JobActivity } from "./types";

const now = () => new Date().toISOString();
const daysFromNow = (n: number) => new Date(Date.now() + n * 86400000).toISOString().slice(0, 10);

const demoCustomers: Customer[] = [
  {
    id: "c1",
    company_name: "Sunset Apparel Co.",
    contact_name: "Alex Reid",
    email: "alex@sunsetapparel.co",
    phone: "+44 7700 900111",
    notes: null,
    created_at: now(),
  },
  {
    id: "c2",
    company_name: "Northwind Merch",
    contact_name: "Priya Patel",
    email: "priya@northwind.merch",
    phone: null,
    notes: null,
    created_at: now(),
  },
  {
    id: "c3",
    company_name: "Ironclad Workwear",
    contact_name: "Jordan Blake",
    email: "jordan@ironclad.co",
    phone: null,
    notes: null,
    created_at: now(),
  },
];

const BASE_JOB = {
  cutting_tier_id: null,
  shipping_method_id: null,
  gangsheet_design_id: null,
  payment_status: "pending" as const,
  assignee_profile_id: null,
  drip_size_id: null,
  metres: null,
  quality_status: null,
};

const demoJobs: Job[] = [
  {
    ...BASE_JOB,
    id: "j1",
    customer_id: "c1",
    job_title: "Tour 2026 Gang Sheet",
    product_type: "DTF Gang Sheet",
    print_size: "A2",
    quantity: 12,
    colours: "Full colour",
    notes: "Use exact pantones from brief",
    status: "Artwork Check",
    due_date: daysFromNow(3),
    created_at: now(),
    updated_at: now(),
    customer: demoCustomers[0],
  },
  {
    ...BASE_JOB,
    id: "j2",
    customer_id: "c2",
    job_title: "Hoodie Pack — Spring Drop",
    product_type: "DTF Transfers",
    print_size: "A3",
    quantity: 80,
    colours: "CMYK",
    notes: null,
    status: "Printing",
    due_date: daysFromNow(1),
    created_at: now(),
    updated_at: now(),
    customer: demoCustomers[1],
  },
  {
    ...BASE_JOB,
    id: "j3",
    customer_id: "c3",
    job_title: "Hi-Vis Logos x250",
    product_type: "DTF Transfers",
    print_size: "A4",
    quantity: 250,
    colours: "1 colour",
    notes: "Reflective ink not required",
    status: "Queued for Print",
    due_date: daysFromNow(5),
    created_at: now(),
    updated_at: now(),
    customer: demoCustomers[2],
  },
  {
    ...BASE_JOB,
    id: "j4",
    customer_id: "c1",
    job_title: "Festival Crew Tees",
    product_type: "DTF Transfers",
    print_size: "A3",
    quantity: 40,
    colours: "2 colour",
    notes: null,
    status: "Ready for Dispatch",
    due_date: daysFromNow(0),
    created_at: now(),
    updated_at: now(),
    customer: demoCustomers[0],
  },
  {
    ...BASE_JOB,
    id: "j5",
    customer_id: "c2",
    job_title: "Pop-up Event Banners",
    product_type: "Gang Sheet",
    print_size: "A2",
    quantity: 6,
    colours: "Full colour",
    notes: null,
    status: "New",
    due_date: daysFromNow(7),
    created_at: now(),
    updated_at: now(),
    customer: demoCustomers[1],
  },
  {
    ...BASE_JOB,
    id: "j6",
    customer_id: "c3",
    job_title: "Repeat Order — Logos",
    product_type: "DTF Transfers",
    print_size: "A4",
    quantity: 100,
    colours: "Full colour",
    notes: null,
    status: "Completed",
    due_date: daysFromNow(-3),
    created_at: now(),
    updated_at: now(),
    customer: demoCustomers[2],
  },
  {
    ...BASE_JOB,
    id: "j7",
    customer_id: "c1",
    job_title: "Sample Pack",
    product_type: "DTF Transfers",
    print_size: "A4",
    quantity: 5,
    colours: "Full colour",
    notes: "Mixed designs",
    status: "Gang Sheet",
    due_date: daysFromNow(2),
    created_at: now(),
    updated_at: now(),
    customer: demoCustomers[0],
  },
];

const demoFiles: JobFile[] = [
  {
    id: "f1",
    job_id: "j1",
    file_name: "tour-front.png",
    file_url: "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=400",
    file_type: "artwork",
    uploaded_at: now(),
  },
  {
    id: "f2",
    job_id: "j2",
    file_name: "spring-logo.png",
    file_url: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400",
    file_type: "artwork",
    uploaded_at: now(),
  },
];

const demoActivity: JobActivity[] = [];

export const demoStore = {
  customers: [...demoCustomers],
  jobs: [...demoJobs],
  files: [...demoFiles],
  activity: [...demoActivity],
};
